<dx-toolbar>
	<dxi-item location="before"
		><span [class]="titleClass"></span>
	</dxi-item>
	<dxi-item location="after" locateInMenu="after" [visible]="!isEditing">
		<dx-button
			text="Szerkesztés"
			icon="edit"
			stylingMode="contained"
			type="default"
			(onClick)="handleEditClick()"
		></dx-button>
	</dxi-item>
	<dxi-item location="after" locateInMenu="after" [visible]="isEditing">
		<dx-button
			text="Mentés"
			stylingMode="contained"
			type="default"
			(onClick)="handleSaveButtonClick($event)"
		></dx-button>
	</dxi-item>
	<dxi-item location="after" locateInMenu="after" [visible]="isEditing">
		<dx-button
			text="Mégsem"
			(onClick)="handleCancelEditClick()"
			stylingMode="outlined"
			type="normal"
		></dx-button>
	</dxi-item>
</dx-toolbar>
